/**
 * NamespaceSelector
 *
 * Compact selector button showing current namespace and a help tooltip; opens
 * the namespaces modal from context. Loading state shows spinner.
 */
import React, { useState } from 'react';
import { Building, ChevronRight, Loader2, HelpCircle } from 'lucide-react';
import { useNamespace } from '../../../context/namespace';

export default function NamespaceSelector() {
  const { 
    currentNamespace, 
    openNamespaceModal, 
    isLoading
  } = useNamespace();
  
  const [showTooltip, setShowTooltip] = useState(false);
  
  const handleClick = () => {
    // We don't need to fetch here anymore,
    // the context handles the initial load.
    // Just open the modal.
    // fetchUserNamespaces(false); // REMOVED THIS LINE
    
    // Open the modal
    openNamespaceModal();
  };
  
  return (
    <div className="relative">
      <button
        onClick={handleClick}
        className="flex items-center justify-between w-full px-3 py-3 mt-2 text-sm rounded-lg bg-gray-50 hover:bg-gray-100 dark:bg-gray-800/50 dark:hover:bg-gray-800 transition-colors"
      >
        <div className="flex items-center gap-2">
          <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-purple-100 dark:bg-purple-900/30">
            {isLoading ? (
              <Loader2 className="h-4 w-4 text-purple-600 dark:text-purple-400 animate-spin" />
            ) : (
              <Building className="h-4 w-4 text-purple-600 dark:text-purple-400" />
            )}
          </div>
          <div className="flex flex-col items-start">
            <span className="text-xs text-gray-500 dark:text-gray-500 font-medium">Namespace</span>
            <span className="text-sm font-medium truncate max-w-[180px] text-gray-900 dark:text-white">{currentNamespace}</span>
          </div>
        </div>
        <div className="flex items-center">
          <div 
            className="mr-1 relative"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            <HelpCircle className="h-4 w-4 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300" />
            
            {showTooltip && (
              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-64 p-3 bg-gray-900 dark:bg-gray-800 text-white text-xs rounded-lg shadow-lg z-20">
                <div className="text-white font-medium mb-1">What are Namespaces?</div>
                <p className="text-gray-300 text-xs">
                  Namespaces help you organize your work by categories, companies, or organizations. All your templates and campaigns are tied to a namespace, making it easy to switch between different projects.
                </p>
                <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 rotate-45 w-2 h-2 bg-gray-900 dark:bg-gray-800"></div>
              </div>
            )}
          </div>
          <ChevronRight className="h-4 w-4 text-gray-400" />
        </div>
      </button>
    </div>
  );
} 